import React, {useState} from "react";
import AceEditor from "react-ace";
import beautify from "js-beautify";
import "ace-builds/src-noconflict/ext-searchbox";
import "ace-builds/src-noconflict/mode-javascript";
// import "ace-builds/src-noconflict/snippets/javascript";
import "ace-builds/src-noconflict/theme-dracula";
import "ace-builds/src-noconflict/keybinding-vscode";
import UtilMenu from "./UtilMenu";
import DeletePopup from "./DeletePopup";
import "./index.scss";

const View = ({
  userScript,
  onChangeScript,
  textSize,
  canZoomIn,
  canZoomOut,
  onClickZoomIn,
  onClickZoomOut,
  isDeletePopupOpen,
  onClickCodeDelete,
  onClickDeleteConfirm,
  currentPath,
}) => {
  const [code, setCode] = useState(userScript);

  const beautifyCode = value => {
    const options = {
      indent_size: "4",
      indent_char: " ",
      max_preserve_newlines: "2",
      preserve_newlines: true,
      keep_array_indentation: false,
      break_chained_methods: false,
      indent_scripts: "keep",
      brace_style: "collapse,preserve-inline",
      space_before_conditional: true,
      unescape_strings: false,
      jslint_happy: false,
      end_with_newline: false,
      wrap_line_length: "100",
      indent_inner_html: false,
      comma_first: false,
      e4x: false,
      indent_empty_lines: false,
    };

    return beautify(value, options);
  };

  const prettifyCode = () => {
    const script = beautifyCode(code);
    setCode(script);
    onChangeScript(script);
  };

  const changeCode = value => {
    setCode(value);
    onChangeScript(value);
  };
  return (
    <div className="ace-editor__wrapper">
      <div className="script_path">{currentPath}</div>
      <AceEditor
        className={"rnd-drag-cancel"}
        mode="javascript"
        theme="dracula"
        keyboardHandler="vscode"
        height="92%"
        width="92%"
        fontSize={textSize}
        showPrintMargin={false}
        setOptions={{
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: true,
          enableSnippets: true,
        }}
        value={code}
        onChange={changeCode}
        // debounceChangePeriod={1000}
      />
      <UtilMenu
        canZoomIn={canZoomIn}
        canZoomOut={canZoomOut}
        onClickZoomIn={onClickZoomIn}
        onClickZoomOut={onClickZoomOut}
        isDeletePopupOpen={isDeletePopupOpen}
        onClickCodeDelete={onClickCodeDelete}
        onClickPrettify={prettifyCode}
      />
      {isDeletePopupOpen && <DeletePopup onClickDeleteConfirm={onClickDeleteConfirm} />}
    </div>
  );
};

export default View;
